import { useEditor } from "@tiptap/react";
import createEditorExtensions from "../components/eventEditor/config";

type UseSetEventEditorProps = {
    content?: string;
};

const useSetEventEditor = ({ content }: UseSetEventEditorProps) => {
    const editor = useEditor({
        extensions: createEditorExtensions(),
        content,
    });

    return {
        editor,
    };
};

export default useSetEventEditor;
